import React from 'react';

import {NucleotideType} from 'biojs/BioConstants';
import {NumberIDFolder} from 'constants/FolderConstants';

export interface UploadingSequenceProps {
  status: string;
  message: string;
  circular: boolean;
  nucleotideType: NucleotideType;
  folder: NumberIDFolder;
  name: string;
}

export default function UploadingSequence({
  status,
  message,
  circular,
  nucleotideType,
  folder,
  name,
}: UploadingSequenceProps): JSX.Element {
  return (
    <div className="row">
      {status === 'error' ? (
        <div className="col col-sm-12 error-row">
          <div className="close pull-right">&times;</div>
          <input type="checkbox" disabled={true} />
          <span className="error-message">{message}</span>
        </div>
      ) : (
        <div className="col col-sm-12">
          <label>
            <div className="pull-right sequence-upload-links">
              <a href="#" target="_blank" rel="noopener noreferrer" className="sequence-link">
                Open Sequence
              </a>
              &nbsp;&middot;&nbsp;
              <span className="sequence-upload-folder">
                uploaded to{' '}
                <a href={folder.url} target="_blank" rel="noopener noreferrer" className="folder-name">
                  {folder.name}
                </a>
              </span>
            </div>
            <input type="checkbox" />
            <span contentEditable={true} suppressContentEditableWarning={true} className="sequence-name">
              {name}
            </span>
            &nbsp;&middot;&nbsp;
            <span className="sequence-topology">{circular ? 'circular' : 'linear'}</span>
            <span className="sequence-nucleotide-type">{` ${nucleotideType}`}</span>
            <div className="tags" />
          </label>
        </div>
      )}
    </div>
  );
}
